// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-navigation[data-v-b66ee972] {\n  width: 800px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.sub-navigation .sub-link[data-v-b66ee972] {\n  font-weight: 500;\n  border: 1px solid #A6A4A6;\n  border-radius: 8px;\n  width: 225px;\n}\n.sub-navigation .router-link-active[data-v-b66ee972],\n.sub-navigation .router-link-exact-active[data-v-b66ee972] {\n  border-bottom: 3px solid #0e9bc0;\n  color: #0e9bc0;\n}", ""]);
// Exports
module.exports = exports;
